import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Route, Router} from '@angular/router';
import {PayService} from '../shared/services/payService/pay.service';
import {Token} from '../pay-method/Token';
import {PayStatus} from '../shared/classes/PayStatus';


const SINGLE = 'single';
const RELAY = 'relay';

@Component({
  selector: 'app-form-page',
  templateUrl: './form-page.component.html',
  styleUrls: ['./form-page.component.css']
})

export class FormPageComponent implements OnInit {

  activate = SINGLE;
  id = undefined;
  payStatus: PayStatus = undefined;

  constructor(private activatedRoute: ActivatedRoute,
              private router: Router,
              private payService: PayService) {
    this.activatedRoute.queryParams.subscribe(params => {
      this.id = params['id'];
      if (this.id !== undefined ) {
        this.payService.getToken().then(data => {
          const token: Token = data as Token;
          this.payService.getStateOfPay(token, this.id).then(response => {
            this.payStatus = response as PayStatus;
          });
        });
      }
    });
  }

  ngOnInit() {
  }

  changeForm(typeOfForm: string) {
    this.activate = typeOfForm;
  }

  hideAlert(){
    this.router.navigate(['/home']);
  }

}
